<template lang="html">
  <div class="w-100 px-3 py-1">
    <b-button-group>
      <b-button :variant="checkedNorm === 1 ? 'primary' : ''" @click="$bus.$emit('change-norm', 1, true)">{{ $t('Webheader.norm_srtp') }}</b-button>
      <b-button :variant="checkedNorm === 2 ? 'primary' : ''" @click="$bus.$emit('change-norm', 2, true)">{{ $t('Webheader.norm_hrtp') }}</b-button>
    </b-button-group>
  </div>
</template>

<script>
import {loadPage, reloadPage2} from './../../../helpers/routing'

export default {
  name: 'MobileNormPicker',
  props: {
    checkedNorm: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      menu: {},
      menuLinkList: null,
      options: [],
      selectedMenu: ''
    }
  },
}
</script>
